<div class="seat-continaer">
  <div
    *ngIf="seatMapLoading"
    class="loader-container"
    style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 200px;
    "
  >
    <ion-spinner name="crescent"></ion-spinner>
    <span style="margin-top: 12px">Loading seats...</span>
  </div>
  <ng-container *ngIf="!seatMapLoading">
    <div class="flight-route bg-white scrollx">
      <ion-chip
        class="route-chip scroll-item"
        *ngFor="let segment of seatMapBySegment; let idx = index"
        (click)="onSegmentClick(idx)"
        [class.active]="selectedSegmentIndex === idx"
      >
        <ion-label>{{ segment.origin }} → {{ segment.destination }}</ion-label>
      </ion-chip>
    </div>

    <div class="price-legend bg-white" *ngIf="seatGrid.length > 0">
      <div class="legend-item" *ngFor="let category of priceCategories">
        <div
          class="legend-color"
          [style.background-color]="category.color"
        ></div>
        <!-- <custom-icon
          iconName="FLIGHT_SEAT_ICON"
          [width]="27"
          [height]="28"
          [color]="category.color"
        ></custom-icon> -->
        <span class="legend-label">{{ category.label }}</span>
      </div>
    </div>

    <div class="seat-map-container" *ngIf="seatGrid.length > 0">
      <!-- <div class="seat-map">
        <div class="seat-row header-row">
          <div class="row-number"></div>
          <ng-container *ngFor="let col of seatColumns; let colIdx = index">
            <div class="seat-header">
              {{ col }}
            </div>
            <ng-template [ngIf]="colIdx === 2">
              <div class="aisle"></div>
            </ng-template>
          </ng-container>
        </div>

        <div class="seat-row" *ngFor="let row of seatGrid; let i = index">
          <div class="row-number">{{ seatRowNumbers[i] }}</div>

          <div
            class="seat"
            [ngStyle]="getSeatStyle(row[0])"
            [class.selected]="isSeatSelected(row[0])"
            (click)="selectSeat(row[0])"
          ></div>
          <div
            class="seat"
            [ngStyle]="getSeatStyle(row[1])"
            [class.selected]="isSeatSelected(row[1])"
            (click)="selectSeat(row[1])"
          ></div>
          <div
            class="seat"
            [ngStyle]="getSeatStyle(row[2])"
            [class.selected]="isSeatSelected(row[2])"
            (click)="selectSeat(row[2])"
          ></div>

          <div class="aisle"></div>

          <div
            class="seat"
            [ngStyle]="getSeatStyle(row[3])"
            [class.selected]="isSeatSelected(row[3])"
            (click)="selectSeat(row[3])"
          ></div>
          <div
            class="seat"
            [ngStyle]="getSeatStyle(row[4])"
            [class.selected]="isSeatSelected(row[4])"
            (click)="selectSeat(row[4])"
          ></div>
          <div
            class="seat"
            [ngStyle]="getSeatStyle(row[5])"
            [class.selected]="isSeatSelected(row[5])"
            (click)="selectSeat(row[5])"
          ></div>
        </div>
      </div> -->
      <div class="seat-map" (click)="clearSeatTooltip()">
        <div class="seat-map-row" 
          *ngFor="let row of seatGrid; let i = index"
        >
          <ng-container *ngFor="let seat of row; let seatIndex = index">
            <div
              class="row-number"
              *ngIf="seatIndex === 0"
              [style.gridColumn]="1"
            >
              {{ seatRowNumbers[i] || "" }}
            </div>
            <ng-container *ngIf="seat?.header; else seatCell">
              <div class="header" [style.gridColumn]="(seat?.xaxis || 0) + 1">
                {{ seat?.colName }}
              </div>
            </ng-container>
            <ng-template #seatCell>
              <ng-container *ngIf="seat?.seatName; else blankSeat">
                <div
                  class="seat"
                  [class.selected]="isSeatSelected(seat)"
                  [class.booked]="isSeatBooked(seat)"
                  (click)="onSeatClick(seat, $event)"
                  [style.gridColumn]="(seat?.xaxis || 0) + 1"
                >
                  <custom-icon
                    [iconName]="getSeatIconName(seat)"
                    [color]="getSeatColor(seat)"
                    [width]="27"
                    [height]="28"
                  ></custom-icon>
                  <div
                    class="seat-tooltip"
                    *ngIf="isTooltipVisible(seat)"
                    [class.edge-left]="isLeftEdgeSeat(seat)"
                    [class.edge-right]="isRightEdgeSeat(seat)"
                    (click)="$event.stopPropagation()"
                  >
                    <ng-container
                      *ngIf="seat?.seatAvailability === 'Closed'; else seatDetails"
                    >
                      <span>{{"flight.seat_selection_modal.Sorry!_This_seat_is_taken" | translate}}</span>
                    </ng-container>
                    <ng-template #seatDetails>
                      <span class="marr2">{{ seat?.seatName }}</span>
                      <span>{{ seat?.seatType }}</span>
                      <span *ngIf="seat?.seatName && getSeatPriceLabel(seat)">
                        |
                      </span>
                      <span>{{ getSeatPriceLabel(seat) }}</span>
                    </ng-template>
                  </div>
                </div>
              </ng-container>
              <ng-template #blankSeat>
                <div
                  class="blank-seat"
                  [style.gridColumn]="(seat?.xaxis || 0) + 1"
                ></div>
              </ng-template>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Show selected seat for each passenger -->

    <div class="footer-content safe-area-bottom">
      <ion-accordion-group>
        <ion-accordion value="first">
          <ion-item slot="header" color="light">
            <div class="seat-info">
              <div class="seat-count">
                Seat(s) selected: {{ selectedSeatsCount }} / {{ numberOfPax }}
              </div>
              <div class="seat-price" *ngIf="selectedSeatsCount > 0">
                {{ getTotalPrice() }}
              </div>
            </div>
          </ion-item>
          <div slot="content">
            <div
              class="selected-seats-list"
              style="padding: 0 16px 8px 16px"
              *ngIf="seatGrid.length > 0"
            >
              <div
                class="selected-seat"
                *ngFor="
                  let pax of [].constructor(numberOfPax);
                  let paxIdx = index
                "
              >
                Passenger {{ paxIdx + 1 }}
                <span
                  *ngIf="getSelectedSeatForPassenger(paxIdx)"
                  class="ion-float-end"
                >
                  {{ getSelectedSeatForPassenger(paxIdx)?.seatName }}
                  ({{
                    getSelectedSeatForPassenger(paxIdx)?.priceDetail?.finalPrice
                      | currency
                        : getSelectedSeatForPassenger(paxIdx)?.priceDetail
                            ?.currency
                  }})
                </span>
                <span
                  class="ion-float-end"
                  *ngIf="!getSelectedSeatForPassenger(paxIdx)"
                  >No seat selected</span
                >
              </div>
            </div>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </div>
  </ng-container>
</div>
